import { render } from "./WatsonAdmin.vue?vue&type=template&id=638d5a21"
import script from "./WatsonAdmin.vue?vue&type=script&lang=js"
export * from "./WatsonAdmin.vue?vue&type=script&lang=js"

import "./WatsonAdmin.vue?vue&type=style&index=0&id=638d5a21&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__